export default {
  title:               'Gestão dos meus dados',
  description:         'Anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos',
  disclaimer:          'De acordo com as <a href="/politica_de_privacidade" target="_blank">políticas de retenção de dados</a>, iremos manter os dados pelo prazo exigido na legislação aplicável para o exercício regular de nossos direitos',
  request_types:       'O que você deseja:',
  anonymization_label: 'Anonimização',
  blocking_label:      'Bloqueio',
  deletion_label:      'Eliminação',
};
